import config from '../config';
import { worldToAxial } from '../coords';
import { getHexTileMapKey } from '../model/keys';
import type { HexTileMapKey } from '../model/types';

interface Vec3 {
  x: number;
  y: number;
  z: number;
}

interface Ray {
  origin: Vec3;
  direction: Vec3;
}

/** Height of the board for picking: the top of land tiles. */
const GROUND_Y = config.hexMap.tile.thickness;

/**
 * Where the ray meets the board's ground plane, with `t` the ray parameter
 * (the distance along it for a unit direction); null if it never does.
 */
function groundPoint(ray: Ray): { x: number; z: number; t: number } | null {
  if (ray.direction.y === 0) return null;
  const t = (GROUND_Y - ray.origin.y) / ray.direction.y;
  if (t < 0) return null;
  return { x: ray.origin.x + ray.direction.x * t, z: ray.origin.z + ray.direction.z * t, t };
}

/** The tile key under a ground point, map bounds aside. */
function groundTileKey(x: number, z: number): HexTileMapKey {
  return getHexTileMapKey(worldToAxial(x, z, config.hexMap.tile.radius));
}

export { GROUND_Y, groundPoint, groundTileKey };
